import { VacationCarryOverRequest } from '../vacation-carry-over-request';
import {
  IVacationCarryOverRequest,
  IVacationCarryOverRequestData
} from '../vacation-carry-over-request.types';

export const mockVacationCarryOverRequestsData = (): IVacationCarryOverRequestData[] => [
  {
    id: 1,
    state: 1,
    employee: {
      id: 164,
      first_name: 'Lamar',
      last_name: 'Falconer',
      type: 1,
      hr_department: {
        id: 1,
        name: 'IT - AltoLeap'
      }
    },
    amount_requested: 12,
    year: 2023,
    reason: 'fggfdf',
    approvers: [
      {
        id: 1,
        approver: {
          id: 3,
          first_name: 'Brandon',
          last_name: 'Puim',
          email: 'bpuim@altoleap.com'
        },
        status: 0,
        created_at: '2023-01-09T19:28:53.432285Z',
        updated_at: '2023-01-09T19:28:53.432332Z'
      }
    ],
    created_at: '2023-01-09T19:28:53.419541Z',
    updated_at: '2023-01-09T19:28:53.601178Z'
  }
];

export const mockVacationCarryOverRequests = (
  data: IVacationCarryOverRequestData[] = mockVacationCarryOverRequestsData()
): IVacationCarryOverRequest[] =>
  data.map(item => new VacationCarryOverRequest(item));
